import { DimensionType } from '../../types';

const DIMENSION_DISPLAY_NAMES: Record<DimensionType, string> = {
  [DimensionType.ANONYMOUS_V2]: 'Anonymous',
  [DimensionType.CONNECTION_TYPE]: 'Connection type',
  [DimensionType.CONTEXT_KIND]: 'Context kind',
  [DimensionType.DESTINATION]: 'Destination',
  [DimensionType.DESTINATION_ID]: 'Destination',
  [DimensionType.DESTINATION_KIND]: 'Destination kind',
  [DimensionType.ENVIRONMENT_ID]: 'Project / environment',
  [DimensionType.EVENT_KIND]: 'Event kind',
  [DimensionType.EVENT_KEY]: 'Event key',
  [DimensionType.EXPERIMENT_ID]: 'Experiment ID',
  [DimensionType.PROJECT_ID]: 'Project',
  [DimensionType.RELAY_VERSION]: 'Relay version',
  [DimensionType.SDK_APP_ID]: 'SDK app ID',
  [DimensionType.SDK_NAME]: 'SDK name',
  [DimensionType.SDK_TYPE]: 'SDK type',
  [DimensionType.SDK_VERSION]: 'SDK version',
  [DimensionType.SDK_VERSION_V1]: 'SDK version',
} as const;

export function getDimensionDisplayName(dimension: DimensionType): string {
  return DIMENSION_DISPLAY_NAMES[dimension] ?? dimension;
}
